module.exports = __webpack_public_path__ + "img/avajanglogo.80b0ffbf.jpg";